import type { FC } from 'react';

import {
  NavigationViewFirstItem,
  NavigationViewGrid,
  NavigationViewSecondItem,
} from '@eneco/custom-components/NavigationView';
import { Stack } from '@eneco/sparky';
import { Placeholder } from '@sitecore/common';
import type { NavigationViewRendering } from '@sitecore/types/NavigationView';

const NavigationView: FC<NavigationViewRendering> = () => (
  <NavigationViewGrid
    alignY="stretch"
    columns="12"
    gap={{
      initial: '3',
      lg: '4',
      xl: '6',
    }}>
    <NavigationViewFirstItem
      gridColumn={{
        initial: '1 / -1',
        md: '1 / 3',
      }}>
      <Placeholder name="jss-navigation-view-first" />
    </NavigationViewFirstItem>
    <NavigationViewSecondItem
      gridColumn={{
        initial: '1 / -1',
        md: '3 / -3',
      }}>
      <Stack gap={{ initial: '10', md: '16' }} direction="column">
        <Placeholder name="jss-navigation-view-second" />
      </Stack>
    </NavigationViewSecondItem>
  </NavigationViewGrid>
);

export { NavigationView };
export default NavigationView;
